import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";

export default function AssignUserDelete(props) {
    const { labType, InstanceID, count, is_userassign } = props;
    const [called, setCalled] = React.useState(false);

    const [state, setState] = React.useState({
        email: "",
        validationError: "",
        errorMessage: "",
    });

    const handleAddForm = () => {
        setCalled(true);
    };

    const handleDialogClose = () => {
        setCalled(false);
    };

    const [deleteSuccessOpen, setDeleteSuccessOpen] = useState(false);
    const handleDeleteSuccessClose = () => {
        setDeleteSuccessOpen(false);
        window.location.reload(false);
    };

    const Delete = (labType, InstanceID) => {
        return function () {
            let labid = InstanceID;
            let labtype = labType;
            fetch(
                `${process.env.REACT_APP_API_URL}/api/deleteuserandassignlab/${labid}/${labtype}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                    body: JSON.stringify({ is_active: "0" }),
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    setCalled(false);
                    setDeleteSuccessOpen(true);
                })
                .catch((error) => {
                    console.error(error);
                    setState({ errorMessage: "Something Went Wrong" });
                });
        };
    };


    return (
        <div>
            <Tooltip title={is_userassign === 'no' ? "No users assigned" : "Delete Assigned User"} arrow>
                <span>
                    <IconButton
                        aria-label="delete"
                        onClick={() => handleAddForm()}
                        disabled={is_userassign === 'no'}
                    >
                        <DeleteIcon />
                    </IconButton>
                </span>
            </Tooltip>
            <Dialog open={called} onClose={handleDialogClose}>
                <DialogTitle>Confirmation !</DialogTitle>
                <DialogContent>
                    <p>Are you sure you want to delete the Trainee assigned to this lab ?</p>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Cancel" arrow>
                        <Button onClick={handleDialogClose} variant="contained" color="secondary" sx={{ borderRadius: '50px', px: 3, py: 1 }}>
                            Cancel
                        </Button>
                    </Tooltip>
                    <Tooltip title="Confirm" arrow>
                        <span>
                            <Button onClick={Delete(labType, InstanceID)} variant="contained" color="primary" autoFocus sx={{ borderRadius: '50px', px: 3, py: 1 }}>
                                Confirm
                            </Button>
                        </span>
                    </Tooltip>
                </DialogActions>
            </Dialog>
            <Dialog open={deleteSuccessOpen} onClose={handleDeleteSuccessClose}>
                <DialogTitle>Notification !</DialogTitle>
                <DialogContent>
                    <p>Assigned Trainees has been deleted successfully.</p>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="OK" arrow>
                        <Button onClick={handleDeleteSuccessClose} color="primary" autoFocus sx={{ borderRadius: '50px', px: 3, py: 1 }}>
                            Ok
                        </Button>
                    </Tooltip>
                </DialogActions>
            </Dialog>
        </div>
    );
}

